"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isNonZeroNumber = function (n) { return typeof n === 'number' && n !== 0; };
var ensureArray = function (v) { return (Array.isArray(v) ? v : [v]); };
var safeString = function (v) { return (v === undefined ? '' : String(v)); };
var maybeAddUnit = function (value, unit) {
    return safeString(value) + (isNonZeroNumber(value) ? unit : '');
};
var stringifyValue = function (value, unit, addUnits) {
    return ensureArray(value)
        .map(function (value) { return (addUnits ? maybeAddUnit(value, unit) : value); })
        .filter(function (v) { return v !== ''; })
        .join(', ');
};
var getStringifiers = function (addUnits) {
    var degrees = function (v) { return stringifyValue(v, 'deg', addUnits); };
    var pixels = function (v) { return stringifyValue(v, 'px', addUnits); };
    var unitless = function (v) { return stringifyValue(v, '', false); };
    var stringifiers = {
        x: function (v) { return "translateX(" + pixels(v) + ")"; },
        y: function (v) { return "translateY(" + pixels(v) + ")"; },
        z: function (v) { return "translateZ(" + pixels(v) + ")"; },
        translate: function (v) { return "translate(" + pixels(v) + ")"; },
        translate3d: function (v) { return "translate3d(" + pixels(v) + ")"; },
        scale: function (v) { return "scale(" + unitless(v) + ")"; },
        scaleX: function (v) { return "scaleX(" + unitless(v) + ")"; },
        scaleY: function (v) { return "scaleY(" + unitless(v) + ")"; },
        scaleZ: function (v) { return "scaleZ(" + unitless(v) + ")"; },
        scale3d: function (v) { return "scale3d(" + unitless(v) + ")"; },
        rotate: function (v) { return "rotate(" + degrees(v) + ")"; },
        rotateX: function (v) { return "rotateX(" + degrees(v) + ")"; },
        rotateY: function (v) { return "rotateY(" + degrees(v) + ")"; },
        rotateZ: function (v) { return "rotateZ(" + degrees(v) + ")"; },
        skew: function (v) { return "skew(" + degrees(v) + ")"; },
        skewX: function (v) { return "skewX(" + degrees(v) + ")"; },
        skewY: function (v) { return "skewY(" + degrees(v) + ")"; },
        perspective: function (v) { return "perspective(" + pixels(v) + ")"; }
    };
    return stringifiers;
};
var stringifiers = getStringifiers(true);
var unitlessStringifiers = getStringifiers(false);
var doTransform = function (s, t) {
    return Object.entries(t || {})
        .map(function (_a) {
        var name = _a[0], value = _a[1];
        var stringifier = s[name];
        if (!stringifier)
            throw new Error("Property '" + name + "' is not supported");
        return stringifier(value);
    })
        .join(' ');
};
var doTranslate = function (s, x, y) {
    return s.translate(y === undefined ? x : [x, y]);
};
exports.transform = function (t) { return doTransform(stringifiers, t); };
exports.transformUnitless = function (t) {
    return doTransform(unitlessStringifiers, t);
};
exports.translate = function (x, y) {
    return doTranslate(stringifiers, x, y);
};
exports.translateUnitless = function (x, y) {
    return doTranslate(unitlessStringifiers, x, y);
};
exports.default = exports.transform;
